module.exports = "https://web-assets.ifttt.com/packs/media/docs/integrate_all_products-d3442385.png";